// store/modules/confirmation.js
import { createPromise } from '@front/common/utils'

const state = () => ({
  confirmPromise: null,
})

const actions = {
  openConfirmation({ commit }) {
    commit('setPromise', createPromise())
  },
  closeConfirmation({ commit }) {
    commit('resetPromise')
  },
  resolve({ state }) {
    if (state.confirmPromise) {
      state.confirmPromise.resolver()
    }
  },
  reject({ state }) {
    if (state.confirmPromise) {
      state.confirmPromise.rejecter()
    }
  },
}

const mutations = {
  setPromise(state, promise) {
    // eslint-disable-next-line no-param-reassign
    state.confirmPromise = promise
  },
  resetPromise(state) {
    // eslint-disable-next-line no-param-reassign
    state.confirmPromise = null
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}
